// Request e-mails (preview -> confirmed send -> history / retry).
// Server: /api/auth/request-emails. Authorization and the exact message are
// decided by the server; the client only shows the draft it got back and quotes
// its `draftHash` when sending.
import config from "../../config.json";

const BASE = `${config.BASE_AUTH_API}request-emails`;

export class RequestEmailError extends Error {
  constructor(message, { status = 0, code = null, details = null } = {}) {
    super(message);
    this.name = "RequestEmailError";
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

async function call(path, token, { method = "GET", body, signal } = {}) {
  let response;
  try {
    response = await fetch(`${BASE}${path}`, {
      method,
      headers: { Accept: "application/json", Authorization: `Bearer ${token}`, ...(body ? { "Content-Type": "application/json" } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {}),
      signal,
    });
  } catch (error) {
    if (error?.name === "AbortError") throw error;
    throw new RequestEmailError("Network error", { code: "NETWORK" });
  }
  const data = await response.json().catch(() => ({}));
  // 200 = everything sent, 202 = sent with failed / unknown applications: both carry a result body
  if (!response.ok || data.success === false) {
    throw new RequestEmailError(data.message || "Request failed", { status: response.status, code: data.code || null, details: data.details || null });
  }
  return data;
}

const enc = encodeURIComponent;
export const getRequestEmailsAPI = (token, source, id, { signal } = {}) => call(`/${enc(source)}/${enc(id)}`, token, { signal });
export const previewRequestEmailAPI = (token, source, id, body, { signal } = {}) => call(`/${enc(source)}/${enc(id)}/preview`, token, { method: "POST", body, signal }).then((data) => data.draft);
export const sendRequestEmailsAPI = (token, source, id, body) => call(`/${enc(source)}/${enc(id)}/send`, token, { method: "POST", body });
export const retryRequestEmailAPI = (token, emailId, body = {}) => call(`/emails/${enc(emailId)}/retry`, token, { method: "POST", body });
